import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b2851ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list"
};
const _hoisted_4 = {
  class: "flex-list",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "notice-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449", -1));
const _hoisted_7 = {
  key: 1,
  class: "notice-text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449", -1));
const _hoisted_9 = {
  key: 2,
  class: "notice-text"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449", -1));
const _hoisted_11 = {
  key: 3,
  class: "notice-text"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449", -1));
const _hoisted_13 = {
  key: 4,
  class: "notice-text"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pay.wedobest.com.cn:8449", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notice-desc"
}, [/*#__PURE__*/_createTextVNode(" 请复制该链接，按 "), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://pm.wedobest.com.cn:8469/#/domainManage"
}, "产品中台-域名管理"), /*#__PURE__*/_createTextVNode(" 中对应域名组的pay业务对应的域名，替换链接标红部分；并配置到华为 AGC 平台-应用内支付-订单/订阅关键事件通知处； ")], -1));
const __default__ = {
  name: 'HuaweiAndroid'
};
import { copy } from '@/common';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {},
    prodChnl: {
      default: 'huawei'
    }
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const publishTypeList = [{
      label: '游戏',
      value: '1'
    }, {
      label: '应用',
      value: '2'
    }];
    const urlList = {
      harmony: 'https://pay.wedobest.com.cn:8449/PayServer/order/callbackHarmony',
      huawei: 'https://pay.wedobest.com.cn:8449/PayServer/order/callbackHuawei',
      huawei_foreign: 'https://pay.wedobest.com.cn:8449/PayServer/order/callbackHuaweiForeign',
      huawei_mg: 'https://pay.wedobest.com.cn:8449/PayServer/order/callbackHarmony',
      huawei_runtime_fastgame: 'https://pay.wedobest.com.cn:8449/PayServer/huaweiRuntimeFastGame/callback'
    };
    const rateList = ref([]); // 分成比例列表
    const huaweiAndroidRef = ref();
    const huaweiAndroidForm = reactive({
      pkg: '',
      appId: '',
      publishType: '1',
      divide: '70%',
      hwPublishKey: '',
      notice: ''
    });
    const validateForm = () => {
      var _huaweiAndroidRef$val;
      (_huaweiAndroidRef$val = huaweiAndroidRef.value) === null || _huaweiAndroidRef$val === void 0 || _huaweiAndroidRef$val.validate().then(() => {
        emit('submitForm', {
          ...huaweiAndroidForm,
          publishKey: huaweiAndroidForm.hwPublishKey
        });
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        huaweiAndroidForm.pkg = n.pkg;
        huaweiAndroidForm.appId = n.appId;
        huaweiAndroidForm.publishType = n.publishType;
        huaweiAndroidForm.hwPublishKey = n.publishKey;
        rateList.value = n.rateList;
        huaweiAndroidForm.divide = n.divide;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        class: "huawei-form",
        model: huaweiAndroidForm,
        ref_key: "huaweiAndroidRef",
        ref: huaweiAndroidRef,
        rules: __props.rules,
        name: "huawei-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: huaweiAndroidForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => huaweiAndroidForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: huaweiAndroidForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => huaweiAndroidForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "publishType",
          label: "产品发布类型："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: huaweiAndroidForm.publishType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => huaweiAndroidForm.publishType = $event),
            disabled: "",
            options: publishTypeList
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: huaweiAndroidForm.divide,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => huaweiAndroidForm.divide = $event),
            options: rateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("华为游戏&华为应用分成比例均为70%")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "hwPublishKey",
          label: "公钥："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_input, {
            value: huaweiAndroidForm.hwPublishKey,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => huaweiAndroidForm.hwPublishKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"]), _createVNode(_component_a_button, {
            class: "img-btn",
            type: "link",
            onClick: _cache[5] || (_cache[5] = $event => emit('setVisible', true))
          }, {
            default: _withCtx(() => [_createTextVNode("图片指引")]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "notice",
          label: "订单/订阅关键事件通知："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [__props.prodChnl === 'harmony' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(" https:// "), _hoisted_6, _createTextVNode(" /PayServer/order/callbackHarmony ")])) : _createCommentVNode("", true), __props.prodChnl === 'huawei' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode(" https:// "), _hoisted_8, _createTextVNode(" /PayServer/order/callbackHuawei ")])) : _createCommentVNode("", true), __props.prodChnl === 'huawei_foreign' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createTextVNode(" https:// "), _hoisted_10, _createTextVNode(" /PayServer/order/callbackHuaweiForeign ")])) : _createCommentVNode("", true), __props.prodChnl === 'huawei_mg' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createTextVNode(" https:// "), _hoisted_12, _createTextVNode(" /PayServer/order/callbackHarmony ")])) : _createCommentVNode("", true), __props.prodChnl === 'huawei_runtime_fastgame' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createTextVNode(" https:// "), _hoisted_14, _createTextVNode(" /PayServer/huaweiRuntimeFastGame/callback ")])) : _createCommentVNode("", true), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode("复制")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "copy",
              "class-name": "copy-icon",
              onClick: _cache[6] || (_cache[6] = $event => _unref(copy)(urlList[__props.prodChnl]))
            })]),
            _: 1
          })]), _hoisted_15]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});